"use client";

import type { TaggedRecipe } from "../../_types/content";
import RecipeLinkCard from "./RecipeLinkCard";
import FeaturedCarousel from "./ui/FeaturedCarousel";

export default function FeaturedRecipeCarousel({
  recipes,
}: {
  recipes: readonly TaggedRecipe[];
}) {
  return (
    <FeaturedCarousel
      title="Featured recipes"
      items={recipes}
      getKey={({ id }) => id}
      renderItem={(recipe) => (
        <RecipeLinkCard recipe={recipe} presentation="carousel" />
      )}
    />
  );
}
